import { useMutation, useQueryClient } from '@tanstack/react-query';
import { restoreContact } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useRestoreContact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: restoreContact,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Message restored successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to restore message';
            toast.error(errorMessage);
        },
    });
};